import { render, staticRenderFns } from "./PaperAgenda.vue?vue&type=template&id=0e8a3338&scoped=true"
import script from "./PaperAgenda.vue?vue&type=script&lang=js"
export * from "./PaperAgenda.vue?vue&type=script&lang=js"
import style0 from "./PaperAgenda.vue?vue&type=style&index=0&id=0e8a3338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a3338",
  null
  
)

export default component.exports